import { render } from "./DatePicker.vue?vue&type=template&id=33597c20"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"

import "./DatePicker.vue?vue&type=style&index=0&id=33597c20&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__